module.exports = __webpack_public_path__ + "static/media/il.6549bc1a.svg";